<template>
  <v-app-bar
    app
    elevation="0"
    class="background mb-10"
    :clipped-right="$vuetify.breakpoint.smAndDown"
  >
    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-app-bar-nav-icon
          v-bind="attrs"
          v-on="on"
          class="hidden-md-and-up"
        ></v-app-bar-nav-icon>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in links" :key="index">
          <!-- <v-list-item-title>{{ item.label }}</v-list-item-title> -->
          <v-list-item-action>
            <v-btn
              class="font-weight-medium"
              plain
              text
              x-large
              link
              :href="item.link"
            >
              {{ item.label }}
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-row
      justify="space-between"
      align="center"
      class="mt-2 hidden-sm-and-down"
    >
      <v-col cols="1" class="d-flex justify-start">
        <v-btn
          class="text-h5 font-weight-medium"
          plain
          text
          x-large
          @click="logout"
        >
          התנתק
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn
          class="text-h5 font-weight-medium"
          plain
          text
          x-large
          link
          :href="'https://primemobile.co.il'"
        >
          צור קשר
        </v-btn>
      </v-col>

      <v-col cols="1">
        <v-btn
          class="text-h5 font-weight-medium"
          plain
          text
          x-large
          link
          :href="'https://primemobile.co.il'"
        >
          אודות
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="text-h5 font-weight-mediumd"
          plain
          text
          x-large
          link
          :href="'https://primemobile.co.il'"
        >
          אפליקציה Prime
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn
          class="text-h5 font-weight-mediumd"
          v-if="adminAccount"
          plain
          text
          x-large
          link
          :to="'/admin'"
        >
          אדמין
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="text-h5 font-weight-mediumd"
          v-if="adminAccount"
          plain
          text
          x-large
          @click="fetchAdminAccount"
        >
          חזור לחשבון אישי
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn icon plain text @click="toggleTheme">
          <v-icon>
            mdi-theme-light-dark
          </v-icon>
        </v-btn>
        <!-- <v-switch
              v-model="$vuetify.theme.dark"
              class="ml-5"
              label="Dark"
            ></v-switch> -->
      </v-col>
      <!-- <v-spacer></v-spacer> -->
      <v-col cols="2" class="d-flex justify-end flex-grow-0 flex-shrink-0 px-0">
        <v-btn plain text x-small>
          <v-img :src="logo.src" :alt="logo.text" class="" max-width="200" />
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import ceil from 'lodash/ceil'
import map from "lodash/map";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import trimStart from "lodash/trimStart";
import uniq from "lodash/uniq";
import filter from "lodash/filter";
import includes from "lodash/includes";
import cloneDeep from "lodash/cloneDeep";
import compact from "lodash/compact";
import concat from 'lodash/concat'
import find from 'lodash/find'
import apiCalls from "@/mixins/apiCalls.js";
import fetchUser from "@/mixins/fetchUser.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppNavbar",
  mixins: [apiCalls, fetchUser],
  data() {
    return {
      logo: {
        src: require("../../assets/primeLogo/Group2x.png"),
        text: "prime",
      },
      links: [
        {
          label: "אפליקציית prime",
          link: "https://primemobile.co.il",
        },
        {
          label: "אודות",
          link: "https://primemobile.co.il",
        },
        {
          label: "צור קשר",
          link: "https://primemobile.co.il",
        },
        // {
        //   label: 'התנתק',
        //   link:
        // },
      ],
      users: null,
      items: null,
      itemsToHide: []
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      isAuthenticated: "isAuthenticated",
      getAccountInformation: "getAccountInfo",
      getAdminAccount: 'getAdminAccount'
    }),
    adminAccount() {
        return this.getAdminAccount
    },
    accountInfo() {
      return this.getAccountInformation;
    },
    hasAdmin() {
      return this.isAuthenticated ? this.isAdmin : false;
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  watch: {
    isIdle(val) {
      if (!val) {
        this.logout();
      }
    },
  },
  methods: {
    ...mapActions([
      "logoutAccount",
      "logoutUser",
      "setAccount",
      "setAccountInfo",
      "setProfile",
      "setUserProfile",
      "setAccountUsers",
      "setAccountOwner",
      "setDetailedUsersList",
      "setInactiveUsers",
      "setAccountPhoneForValidation",
    ]),
    toggleTheme() {
      if(this.$vuetify.theme.dark) this.$vuetify.theme.dark = false;
      else this.$vuetify.theme.dark = true
    },
    logout() {
      this.$store.dispatch("logoutAccount");
      this.$store.dispatch("logoutUser");
      this.$router.push("/");
    },
    //mixin
    async getAccountInfo() {
      const appAction = false;
      const functionName = "get_account_info";
      const reqBody = {
        account_id: this.adminAccount.domain_id,
      };
      try {
        const data = await this.makeApiRequest(
          appAction,
          functionName,
          reqBody
        );
        if (data.error_code === 200) {
          await this.$store.dispatch("setAccountInfo", data.data);
          this.accountInfo;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchAdminAccount() {
      this.$store.dispatch("setAccount", this.adminAccount);
      await this.getAccountInfo();
      await this.getUsers();
      await this.getDetailedUsersList();
      this.loadForAccountOwner()
    },
    async loadForAccountOwner() {
      const accountUser = await this.getUser(this.adminAccount);
      await this.$store.dispatch("setUserProfile", accountUser);
      this.$store.dispatch("setAccountOwner", true);
      this.$store.dispatch("setAccountUsers", this.users);
      this.$router.push(`/account/${this.adminAccount.domain_id}/profile`);
    },
    accountOwnerUser(user) {
      if (isEqual(this.account.domain_user_id, user.domain_user_id))
        return user;
      else return;
    },
    async getUsers() {
      let accauntUsersPages = this.accountInfo.users_amount / 40;
      const appAction = false;
      const functionName = "get_users";
    
      for (let i = 0; i <= ceil(accauntUsersPages) - 1; i++) {
        const reqBody = {
          account_id: this.adminAccount.domain_id,
          page: i,
        };
        const data = await this.makeApiRequest(
          appAction,
          functionName,
          reqBody
        );
        if (data.error_code === 200) {
          this.users = concat(this.users, data.data);
        }
        this.users = compact(this.users);
      }
    },
    async getDetailedUsersList() {
      this.items = await Promise.all(
        this.users.map(async (el) => {
          const response = await this.getUser(el);
          return await response;
        })
      );
      let accountOwnerForPhone = find(this.items, "is_account_owner");
      let phone = "+" + this.findPhone(accountOwnerForPhone);
      await this.$store.dispatch("setAccountPhoneForValidation", phone);
      let active = filter(this.items, (el) => {
        return this.filter(el);
      });
      let accountOwner = find(active, (el) => {
        return this.accountOwnerUser(el);
      });
      active = concat([accountOwner], active);
      active = uniq(active);
      this.$store.dispatch("setDetailedUsersList", active);
      this.$store.dispatch("setInactiveUsers", this.itemsToHide);
      return;
    },
    filter(user) {
      if (
        user.active &&
        user.endpoint_amount > 0 &&
        !isEmpty(user.base_package)
      )
        return user;
      else this.itemsToHide.push(user);
    },
    findItem() {
      let number = trimStart(this.userPhone, "+");
      let items = cloneDeep(this.items);
      let item = map(items, (el) => {
        if (el.main_cid == number) return el;
        if (el.profile.contact_phone == number) return el;
        if (includes(el.main_cid_options, number)) return el;
      });
      return compact(item);
    },
    findPhone(accountOwnerForPhone) {
      // console.log('findPhone(accountOwnerForPhone)', accountOwnerForPhone );
      let phone;
      if (accountOwnerForPhone.main_cid) phone = accountOwnerForPhone.main_cid;
      if (accountOwnerForPhone.profile.contact_phone)
        phone = accountOwnerForPhone.profile.contact_phone;
      if (accountOwnerForPhone.main_cid_options.length > 0)
        phone = accountOwnerForPhone.main_cid_options[0];
      return phone;
    },
  },
};
</script>

<style lang="sass">
#app > div > header > div > button > span > i
  font-size: 40px
</style>
